import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";

import App from "./App";
import "./index.css";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.MODE,
  release: import.meta.env.VITE_APP_VERSION,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  tracesSampleRate: 0.3,
  beforeSend(event) {
    const status = event.exception?.values?.[0]?.value;

    if (
      status?.includes("401") ||
      status?.includes("403") ||
      status?.includes("canceled")
    ) {
      return null;
    }

    return event;
  },
});

const AppWithSentry = Sentry.withErrorBoundary(App, {
  fallback: <p>Erro inesperado.</p>,
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AppWithSentry />
  </React.StrictMode>,
);
